import actTemplateApi from '@/api/act'
import Vue from 'vue'

const defaultState = () => ({
    vehicleOptions: [
        {id: 1, name: 'Відібражати текст'},
        {id: 2, name: 'Видалити текст'}
    ],
    locationOptions: [
        {id: 1, name: 'Відібражати текст'},
        {id: 2, name: 'Видалити текст'},
        {id: 3, name: 'Короткий текст'},
    ],
})

const INDEX_MODULE = {
    namespaced: true,
    state: defaultState(),
    getters: {},
    mutations: {},
    actions: {
        async sendForm({}, {form, onCloseModal}) {
            try {
                await actTemplateApi.createActTemplate(form)

                onCloseModal()
            } catch (e) {
                console.error(e)
            }
        },
        async destroyAct({}, {id, onCloseModal}) {
            try {
                await actTemplateApi.deleteActTemplate(id)

                onCloseModal()
            } catch (e) {
                console.error(e)
            }
        },
        async getActTemplates({}, client_id) {
            try {
                const {data} = await actTemplateApi.getActTemplates({client_id: client_id})

                return data
            } catch (e) {
                console.error(e)
            }
        }
    }
}

export default INDEX_MODULE
